import styled, {css} from 'styled-components';
import {ButtonProps} from './Button';
import {OriginalButtonProps} from './OriginalButton';
import {device} from '../../styled/device';

const defaultWidth = '210px';
const shortWidth = '135px';

export const StyledButton = styled.button<
  Pick<
    ButtonProps,
    | 'short'
    | 'onClick'
    | 'disabled'
    | 'type'
    | 'secondary'
    | 'whiteButton'
    | 'blackButton'
  >
>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  position: relative;
  background: transparent linear-gradient(166deg, #385cf8 0%, #2148ff 100%) 0 0 no-repeat
    padding-box;
  box-shadow: 0 3px 4px #00020334;
  border-radius: 25px;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: Poppins-Medium, sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  text-align: left;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  user-select: none;
  padding: ${props => (props.short ? '0 25px' : '0 50px')};
  min-width: ${props => (props.short ? shortWidth : defaultWidth)};
  max-width: fit-content;
  line-height: 0;

  &:hover {
    background: transparent linear-gradient(166deg, #0025d4 0%, #0025d4 100%) 0 0
      no-repeat padding-box;
  }

  &:active {
    opacity: 1;
  }

  .iconRight {
    position: absolute;
    right: 22px;
  }

  .buttonLabel {
    padding: ${props => (props.short ? '0 25px' : 'none')};
    white-space: nowrap;
  }

  @media (max-width: ${device.mobileM}) {
    font-size: 20px;
    font-weight: 500;
    height: 54px;
    // padding: 0 15px;
    text-align: center;

    .iconRight {
      display: none;
    }
  }

  ${props =>
    props.secondary &&
    css`
      color: #23262f;
      padding: 0;
      min-width: min-content;
      box-shadow: none;
      background: transparent;

      &:hover {
        opacity: 0.7;
        background: transparent;
      }
    `};

  ${props =>
    props.whiteButton &&
    css`
      display: flex;
      flex-wrap: nowrap;
      height: 40px;
      min-width: min-content;
      font-size: 14px;
      font-weight: 500;
      padding: 0 30px;
      background: white;
      box-shadow: 0 0 0 2px #e6e8ec inset;
      color: #23262f;

      &:hover {
        background: #23262f;
        box-shadow: 0 0 0 2px #23262f inset;
        color: white;
      }

      @media (max-width: ${device.mobileM}) {
        align-items: center;
        justify-content: center;
        min-width: 290px;
        padding: 25px 0;
        font-size: 20px;
      }
    `};
  ${props =>
    props.blackButton &&
    css`
      min-width: min-content;
      font-size: 18px;
      font-weight: 500;
      padding: 0 35px;
      background: #353945;
      box-shadow: 0 0 0 2px #353945 inset;
      color: white;

      &:hover {
        background: white;
        box-shadow: 0 0 0 1px #353945 inset;
        color: black;
        font-size: 18px;
        font-weight: 500;
      }
    `};

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `};
`;

export const StyledOriginalButton = styled.button<Partial<OriginalButtonProps>>`
  height: 40px;
  background: transparent linear-gradient(164deg, #385cf8 0%, #2148ff 100%) 0 0 no-repeat
    padding-box;
  box-shadow: 0 3px 4px #00020334;
  min-width: 117px;
  border-radius: 6px;
  outline: none;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  text-align: left;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  transition: all 0.07s ease-in-out;
  user-select: none;
  border: none;
  justify-content: center;

  &:hover {
    opacity: 0.9;
    box-shadow: none;
  }
  &:active {
    opacity: 1;
  }
  & > img {
    margin-right: 12px;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.1;
      &:hover {
        opacity: 0.1;
        box-shadow: none;
      }
      &:active {
        opacity: 0.1;
      }
    `};
  ${props =>
    props.link &&
    css`
      border: none;
      color: #002cfa;
      font-family: 'Poppins', sans-serif;
      background: white;
      box-shadow: none;
      &:hover {
        opacity: 0.7;
      }
      &:active {
        opacity: 1;
      }
    `};

  @keyframes blink {
    0% {
      border-color: #d7d8e4;
    }
    50% {
      border-color: #385cf8;
    }
    0% {
      border-color: #d7d8e4;
    }
  }
`;

export const OriginalButtonLabel = styled.div`
  height: 36px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  & > img {
    margin-right: 12px;
  }
`;

export const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  padding-right: 15px;
`;
